<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button
                            class="btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Payment Methods</div>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>

                <div class="row w100 m-auto">
                    <div *ngIf="userStoreService?.outComeText" class="col-12 alert alert-info" role="alert">&nbsp;<span [innerHTML]="userStoreService?.outComeText"></span></div>
                    <div  *ngIf="errorMessage || sucessMessage">
                        <div class="col-12 alert alert-info" role="alert" *ngIf="sucessMessage"  > &nbsp;<span [innerHTML]="sucessMessage"></span></div>
                        <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage"  > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                     </div>
                    <div class="col-12 col-sm-12">
               
                        
                        <div class="billing-detail">
                            <div  *ngIf="!(userStoreService?.getUserProfile()?.paymentDevices?.length)">
                                <div class="col-12 col-sm-12">
                                    <div class="col-12 alert alert-danger" role="alert">
                                         There is no payment method available in your profile.
                                    </div>
                                </div>
                            </div>
                            <div class="billing-detail-row" *ngFor="let paymentDevice of userStoreService?.getUserProfile()?.paymentDevices">
                                <div class="row">
                                    <div class="col-10 col-sm-11">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="rectangle-wrapper">
                                                    <div class="row w100">
                                                    <div class="cardName col-6 col-sm-6">{{paymentDevice?.shortName}} (******{{paymentDevice.accountLast4}})</div>
                                                    <div class="col-6 col-sm-6 expiration" *ngIf="paymentDevice?.expiration">
                                                        {{paymentDevice?.expiration}}
                                                    </div>
                                                    </div>
                                                </div>

                                                <div class="rectangle-wrapper display-webkit-box">
                                                    <div class="row w100">
                                                        <div class="col-6 col-sm-6 grayC">
                                                            {{paymentDevice?.type}}
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-sm-12">
                                                <div class="billing-disabledLable">
                                                  {{getagencyById(paymentDevice?.agencyID)}}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-2 col-sm-1 m-auto display-type-webkit-box p-0">
                                        <div class="m-auto d-flex a-i-c">
                                        <div class="deleteIcon">
                                            <i  (click)="edit(paymentDevice)" > <svg-image   color="#b2b2b2" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                                           
                                        </div>
                                        <div class="deleteIcon">
                                            <img class="img-fluid" src="{{globalService?.staticResourceURL}}/assets/images/trash.svg" (click)="delete(paymentDevice)">
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="container mt-5  text-center">
                <a><button class="btn btn-primary  btn-continue m-auto" (click)="close()">Close</button></a></div>
        </div>
    </div>
</div>